var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDeskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0C2.02065 0 1.32118 0.289731 0.805456 0.805456C0.289731 1.32118 0 2.02065 0 2.75V15.5778C0 16.3072 0.289731 17.0067 0.805456 17.5224C1.32118 18.0381 2.02065 18.3278 2.75 18.3278H7.33333V20.1667H4.57233C4.32922 20.1667 4.09606 20.2632 3.92415 20.4352C3.75224 20.6071 3.65567 20.8402 3.65567 21.0833C3.65567 21.3264 3.75224 21.5596 3.92415 21.7315C4.09606 21.9034 4.32922 22 4.57233 22H17.4148C17.6579 22 17.8911 21.9034 18.063 21.7315C18.2349 21.5596 18.3315 21.3264 18.3315 21.0833C18.3315 20.8402 18.2349 20.6071 18.063 20.4352C17.8911 20.2632 17.6579 20.1667 17.4148 20.1667H14.6648V18.3278H19.25C19.9793 18.3278 20.6788 18.0381 21.1945 17.5224C21.7103 17.0067 22 16.3072 22 15.5778V2.75C22 2.02065 21.7103 1.32118 21.1945 0.805456C20.6788 0.289731 19.9793 0 19.25 0H2.75ZM12.8333 18.3278V20.1667H9.16483V18.3278H12.8315H12.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDeskIcon);
export default __webpack_public_path__ + "static/media/open-desk-icon.90ee24c9d87b4cf94964bf355f0fdfce.svg";
export { ForwardRef as ReactComponent };